import { useRouterState } from "@tanstack/react-router";

import { createBreadcrumbs } from "src/convenience/breadcrumbs";

import { useBaseStaticCtx } from "./useBaseStaticCtx";

export function useBreadcrumbs() {
  const matches = useRouterState({
    select: (state) => {
      return state.matches;
    },
  });
  const ctx = useBaseStaticCtx();

  return createBreadcrumbs(matches, ctx);
}
